var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"abiturient-layout grey lighten-3"},[_c('Header'),_c('v-container',{staticClass:"pt-5 pb-5"},[_c('main',{staticClass:"abiturient-layout__main",staticStyle:{"min-height":"60vh"}},[_c('router-view',{key:_vm.$route.fullPath})],1)]),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }